<template>
  <div class="text-truncate">
    <v-btn
      flat
      large
      :loading="loading"
      @click="ConfirmLeistung();"
    >  
      <v-icon left>{{ !hasLeistung ? 'check_box_outline_blank' :  'check_box' }}</v-icon>
      {{ leistung.leistung }}
    </v-btn>
  </div>
</template>

<script>
// import { mapGetters } from 'vuex'
import axios from 'axios'

export default {
  props: ['leistung', 'betrieb'],

  data () {
    return {
      loading: false
     // betrieb.checkloading: true
    }
  },
  mounted: function () {},
  computed: {
    hasLeistung: function () {
      if (this.betrieb) {
        if (this.betrieb.leistungen) {
          var arrR = this.betrieb.leistungen.filter(function (ele) {
            return ele.id === this.leistung.id
          }, this)
          if (arrR.length) {
            return true
          } else {
            return false
          }
        }
      }
    }
  },
  methods: {
    ConfirmLeistung () {
      this.loading = true
      const daten = {
        id: this.betrieb.id,
        leistung: this.leistung,
        route: this.$store.state.route,
        signature: this.$store.state.route.query.signature
      }
      axios
        .post('datencheck', daten)
        .then((resp) => {
          this.$store.dispatch('responseMessage', {
            type: 'success',
            title: 'Erfolgreich gemeldet ',
            text: 'Status erfolgreich geändert!'
          })
          this.loading = false
        })
        .catch((resp) => {
          console.log('error: ')
          console.log(resp)
          this.$store.dispatch('responseMessage', {
            type: 'error',
            title: 'Da ist leider etwas schiefgegangen',
            text: 'Fehlgeschlagen, bitte kontaktieren Sie info@lokaleshandwerk.de'
          })
        })
        .finally(() => {
          this.$emit('calledback')

         // this.getData()
          this.loading = false
        })
    }
  }
}
</script>

<style>
</style>
